export default __webpack_public_path__ + "static/media/miva-Ecommerce-Platform.509849b8.png";